import React from 'react';
import { Link } from 'react-router-dom';

// Imágenes
import ImgPresionConstante from '../img/products/equiposDePresion/PresionConstante.png';
import ImgPresionDiferencial from '../img/products/equiposDePresion/PresionDiferencial.png';

const presiones = [
    { nombre: 'Equipos de Presión Constante', ruta: '/EquiposDePresionConstante', img: ImgPresionConstante },
    { nombre: 'Equipos de Presión Diferencial', ruta: '/EquiposDePresionDiferencial', img: ImgPresionDiferencial },
];

const EquiposDePresion = () => {
    return (
        <div className="container my-5">
            <h3 className="mb-4 text-center">Equipos de Presión</h3>
            <div className="row row-cols-1 row-cols-md-2 g-4">
                {presiones.map((presion, index) => (
                    <div className="col" key={index}>
                        <div className="card h-100 shadow-sm">
                            <Link to={presion.ruta} className="text-decoration-none text-dark">
                                <img
                                    src={presion.img}
                                    className="card-img-top"
                                    alt={presion.nombre}
                                    style={{
                                        height: '220px',
                                        objectFit: 'cover',
                                        width: '100%',
                                    }}
                                />
                                <div className="card-body text-center">
                                    <h5 className="card-title">{presion.nombre}</h5>
                                </div>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EquiposDePresion;
